export const SelectedListModel = Symbol.for('SelectedListModel');
